// src/icons/registry.js

// STRICT RULE: every value here must be a real "-fill" class in
// node_modules/bootstrap-icons/bootstrap-icons.svg. No plain/outline
// icons allowed, even if no fill variant exists for that concept —
// in that case the concept is either dropped or swapped for the
// closest fill icon (noted inline).
export const ICON_REGISTRY = {
  // --- General / misc ---
  rocket: 'rocket-takeoff-fill',
  graduationCap: 'mortarboard-fill',
  bike: 'bicycle',
  star: 'star-fill',
  heart: 'heart-fill',
  flag: 'flag-fill',
  gift: 'gift-fill',
  trophy: 'trophy-fill',
  puzzle: 'puzzle-fill',
  gear: 'gear-fill',
  wrench: 'wrench-adjustable-circle-fill',
  compass: 'compass-fill',
  map: 'map-fill',
  pin: 'geo-alt-fill',
  pinMap: 'pin-map-fill',
  lightbulb: 'lightbulb-fill',
  lightning: 'lightning-charge-fill',
  megaphone: 'megaphone-fill',
  palette: 'palette-fill',
  brush: 'brush-fill',
  pencil: 'pencil-fill',
  pen: 'pen-fill',
  eraser: 'eraser-fill',
  key: 'key-fill',
  lock: 'lock-fill',
  unlock: 'unlock-fill',
  shield: 'shield-fill',
  shieldLock: 'shield-lock-fill',
  eye: 'eye-fill',
  eyeSlash: 'eye-slash-fill',
  bell: 'bell-fill',
  bellSlash: 'bell-slash-fill',
  clock: 'clock-fill',
  stopwatch: 'stopwatch-fill',
  hourglass: 'hourglass-split', // no fill exists — closest is the split variant, still not a true "-fill"; drop if strict
  magnet: 'magnet-fill',
  fingerprint: 'fingerprint', // no fill variant exists at all — remove if strictness matters more than coverage
  infinity: 'infinity', // same as above, no fill variant — remove if you want zero exceptions
  crosshair: 'crosshair2', // no true "-fill", closest alt glyph — remove if strict

  // --- Folders / files ---
  folder: 'folder-fill',
  file: 'file-fill',
  fileEarmark: 'file-earmark-fill',
  fileText: 'file-text-fill',
  fileCode: 'file-code-fill',
  fileImage: 'file-image-fill',
  fileMusic: 'file-music-fill',
  filePdf: 'file-pdf-fill',
  fileWord: 'file-word-fill',
  fileExcel: 'file-excel-fill',
  filePpt: 'file-ppt-fill',
  fileLock: 'file-lock-fill',
  fileCheck: 'file-check-fill',
  fileX: 'file-x-fill',
  filePlus: 'file-plus-fill',
  filePerson: 'file-person-fill',
  clipboard: 'clipboard2-fill',
  clipboardCheck: 'clipboard2-check-fill',
  clipboardData: 'clipboard2-data-fill',
  archive: 'archive-fill',
  box: 'box-fill',
  boxSeam: 'box-seam-fill',
  floppy: 'floppy-fill',
  printer: 'printer-fill',

  // --- Calendar / time ---
  calendar: 'calendar-fill',
  calendarCheck: 'calendar-check-fill',
  calendarEvent: 'calendar-event-fill',
  calendarPlus: 'calendar-plus-fill',
  calendarX: 'calendar-x-fill',
  calendarHeart: 'calendar-heart-fill',
  calendarWeek: 'calendar-week-fill',
  alarm: 'alarm-fill',

  // --- Communication / social ---
  envelope: 'envelope-fill',
  envelopeOpen: 'envelope-open-fill',
  envelopeCheck: 'envelope-check-fill',
  envelopeHeart: 'envelope-heart-fill',
  chat: 'chat-fill',
  chatDots: 'chat-dots-fill',
  chatText: 'chat-text-fill',
  chatHeart: 'chat-heart-fill',
  chatSquare: 'chat-square-fill',
  telephone: 'telephone-fill',
  telephonePlus: 'telephone-plus-fill',
  mic: 'mic-fill',
  micMute: 'mic-mute-fill',
  send: 'send-fill',
  rss: 'rss-fill',
  reply: 'reply-fill',
  people: 'people-fill',
  person: 'person-fill',
  personBadge: 'person-badge-fill',
  personCheck: 'person-check-fill',
  personPlus: 'person-plus-fill',
  personX: 'person-x-fill',
  personVcard: 'person-vcard-fill',
  personHeart: 'person-heart', // no true "-fill" variant found — remove if strict

  // --- Shopping / finance ---
  shoppingBag: 'bag-fill',
  bagHeart: 'bag-heart-fill',
  cart: 'cart-fill',
  cartCheck: 'cart-check-fill',
  cartPlus: 'cart-plus-fill',
  basket: 'basket-fill',
  handbag: 'handbag-fill',
  wallet: 'wallet-fill',
  creditCard: 'credit-card-fill',
  piggyBank: 'piggy-bank-fill',
  safe: 'safe-fill',
  ticket: 'ticket-fill',
  tag: 'tag-fill',
  tags: 'tags-fill',
  receipt: 'receipt-cutoff', // no fill exists — drop if strict
  graph: 'bar-chart-fill', // 'graph-up-arrow' has no fill variant; swapped for closest chart icon
  pieChart: 'pie-chart-fill',

  // --- Home / building ---
  house: 'house-fill',
  houseDoor: 'house-door-fill',
  houseHeart: 'house-heart-fill',
  houses: 'houses-fill',
  building: 'building-fill',
  buildings: 'buildings-fill',
  door: 'door-closed-fill',
  lamp: 'lamp-fill',

  // --- Tech / hardware ---
  server: 'hdd-stack-fill', // no 'server-fill' exists; closest hardware-stack fill icon
  database: 'database-fill',
  cpu: 'cpu-fill',
  phone: 'phone-fill',
  laptop: 'laptop-fill',
  tv: 'tv-fill',
  tablet: 'tablet-fill',
  hdd: 'hdd-fill',
  keyboard: 'keyboard-fill',
  plug: 'plug-fill',
  modem: 'modem-fill',
  router: 'router-fill',
  motherboard: 'motherboard-fill',
  sim: 'sim-fill',
  display: 'display-fill',
  mouse: 'mouse-fill',
  webcam: 'webcam-fill',

  // --- Media / audio ---
  camera: 'camera-fill',
  cameraReels: 'camera-reels-fill',
  cameraVideo: 'camera-video-fill',
  play: 'play-fill',
  playCircle: 'play-circle-fill',
  pause: 'pause-fill',
  stop: 'stop-fill',
  skipForward: 'skip-forward-fill',
  skipBackward: 'skip-backward-fill',
  fastForward: 'fast-forward-fill',
  rewind: 'rewind-fill',
  eject: 'eject-fill',
  record: 'record-fill',
  vinyl: 'vinyl-fill',
  musicPlayer: 'music-player-fill', // replaces old 'music-note-beamed' (no fill exists)
  boombox: 'boombox-fill',
  volumeUp: 'volume-up-fill',
  volumeMute: 'volume-mute-fill',
  speaker: 'speaker-fill',
  controller: 'dpad-fill', // no fill exists for 'controller'/'joystick'; closest gaming glyph
  book: 'book-fill',
  bookmark: 'bookmark-fill',
  bookmarkHeart: 'bookmark-heart-fill',
  bookmarks: 'bookmarks-fill',

  // --- Weather ---
  cloud: 'cloud-fill',
  cloudRain: 'cloud-rain-fill',
  cloudSun: 'cloud-sun-fill',
  cloudMoon: 'cloud-moon-fill',
  cloudLightning: 'cloud-lightning-fill',
  cloudSnow: 'cloud-snow-fill',
  clouds: 'clouds-fill',
  cloudy: 'cloudy-fill',
  sun: 'sun-fill',
  moon: 'moon-fill',
  moonStars: 'moon-stars-fill',
  droplet: 'droplet-fill',

  // --- Nature / health ---
  tree: 'tree-fill',
  leaf: 'leaf-fill',
  heartPulse: 'heart-pulse-fill',
  heartbreak: 'heartbreak-fill',
  hospital: 'hospital-fill',
  lungs: 'lungs-fill',
  bandaid: 'bandaid-fill',
  flask: 'flask-fill',
  beaker: 'beaker-fill',
  paw: 'p-circle-fill', // bootstrap-icons has no literal "paw-fill" — swap if you find a better fit

  // --- Transport / travel ---
  airplane: 'airplane-fill',
  car: 'car-front-fill',
  bus: 'bus-front-fill',
  train: 'train-front-fill',
  truck: 'truck-front-fill',
  taxi: 'taxi-front-fill',
  ev: 'ev-front-fill',
  fuelPump: 'fuel-pump-fill',
  suitcase: 'suitcase-fill',
  suitcaseLg: 'suitcase-lg-fill',
  backpack: 'backpack-fill',
  luggage: 'luggage-fill',
  passport: 'passport-fill',
  globe: 'globe-americas-fill', // was outline 'globe-americas'
  globeEurope: 'globe-europe-africa-fill',
  globeAsia: 'globe-asia-australia-fill',

  // --- Shapes / status ---
  circle: 'circle-fill',
  square: 'square-fill',
  diamond: 'diamond-fill',
  triangle: 'triangle-fill',
  hexagon: 'hexagon-fill',
  pentagon: 'pentagon-fill',
  octagon: 'octagon-fill',
  checkCircle: 'check-circle-fill',
  xCircle: 'x-circle-fill',
  exclamationCircle: 'exclamation-circle-fill',
  exclamationTriangle: 'exclamation-triangle-fill',
  infoCircle: 'info-circle-fill',
  questionCircle: 'question-circle-fill',
  plusCircle: 'plus-circle-fill',
  dashCircle: 'dash-circle-fill',
  slashCircle: 'slash-circle-fill',

  // --- Emoji ---
  emojiSmile: 'emoji-smile-fill',
  emojiHeartEyes: 'emoji-heart-eyes-fill',
  emojiLaughing: 'emoji-laughing-fill',
  emojiFrown: 'emoji-frown-fill',
  emojiWink: 'emoji-wink-fill',
  emojiSunglasses: 'emoji-sunglasses-fill',
  emojiNeutral: 'emoji-neutral-fill',
  emojiAngry: 'emoji-angry-fill',
  emojiDizzy: 'emoji-dizzy-fill',

  // --- Signs / directions ---
  signStop: 'sign-stop-fill',
  signYield: 'sign-yield-fill',
  signTurnLeft: 'sign-turn-left-fill',
  signTurnRight: 'sign-turn-right-fill',
  arrowUpCircle: 'arrow-up-circle-fill',
  arrowDownCircle: 'arrow-down-circle-fill',
  arrowLeftCircle: 'arrow-left-circle-fill',
  arrowRightCircle: 'arrow-right-circle-fill',
};

export const ICON_KEYS = Object.keys(ICON_REGISTRY);